import { Grid } from "@mui/material"
import { AxiosPromise } from "axios"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import FileStatistics from "../components/statistics/file"
import StatisticFileTable from "../components/statistics/file-table"
import UserStatistics from "../components/statistics/user"
import StatisticUserTable from "../components/statistics/user-table"
import { AppDispatch, RootState } from "../store"
import {
	getFileStatistics,
	getUserStatistics,
} from "../store/actions/statistics"

const HomePage: React.FunctionComponent = () => {
	const dispatch = useDispatch<AppDispatch>()
	const isAuthenticate: boolean = useSelector(
		(state: RootState) => state.auth.isAuthenticate
	)
	const isLoadingUserStatistics = useSelector(
		(state: RootState) => state.statistics?.user?.isLoading
	)
	const isLoadingFileStatistics = useSelector(
		(state: RootState) => state.statistics?.file?.isLoading
	)

	useEffect(() => {
		if (isAuthenticate) {
			dispatch(getUserStatistics())
				.then((response: AxiosPromise) => {})
				.catch(() => {})

			dispatch(getFileStatistics())
				.then((response: AxiosPromise) => {})
				.catch(() => {})
		}
	}, [isAuthenticate])

	return (
		<Grid container>
			<Grid item sx={{ marginTop: "16px", width: "100%" }}>
				<UserStatistics />
			</Grid>
			{!isLoadingUserStatistics && (
				<Grid item sx={{ marginTop: "16px", width: "100%" }}>
					<StatisticUserTable />
				</Grid>
			)}
			<Grid item>
				<FileStatistics />
			</Grid>
			{!isLoadingFileStatistics && (
				<Grid item sx={{ marginTop: "16px", width: "100%" }}>
					<StatisticFileTable />
				</Grid>
			)}
		</Grid>
	)
}

export default HomePage
